// extracted by mini-css-extract-plugin
export var errorIcon = "_qu-1";
export var nameLogo = "_qu-0";